import LayerGroup from 'ol/layer/Group';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import {urlWMSLastebd, formatoPNG } from './configuracion'; 
  
const layer05 = new TileLayer({
  title: 'Parque Nacional',
  source: new TileWMS({
    url: urlWMSLastebd,
    params: {LAYERS: 'parque_nacional', format: formatoPNG},
    gutter: 200,
  })
});
  
const layer06 = new TileLayer({
  title: 'Parque Natural',
  source: new TileWMS({
    url: urlWMSLastebd,
    params: {LAYERS: 'parque_natural', format: formatoPNG},
    gutter: 200,
  })
});
layer06.setVisible(false);
  
const layer07 = new TileLayer({
  title: 'Reserva Biósfera',
  source: new TileWMS({
    url: urlWMSLastebd,
    params: {LAYERS: 'reserva_biosfera', format: formatoPNG},
    gutter: 200,
  })
});
layer07.setVisible(false);

const layer08 = new TileLayer({
  title: 'Reserva Biológica',
  source: new TileWMS({
    url: urlWMSLastebd,
    params: {LAYERS: 'reservas_biológicas', format: formatoPNG},
    gutter: 200,
  })
});
layer08.setVisible(false);

export const grupoCapa03 = new LayerGroup({
  title: 'Espacios Naturales Protegidos',
  fold: 'close',
  layers: [layer05, layer06, layer07, layer08]
});